import { makeStyles, Text, tokens } from '@fluentui/react-components';
import emptyActivityIcon from 'src/assets/svg/empty-activity.svg';

interface EmptyActivitiesProps {
	title: string;
	description: string;
}

export default function EmptyActivities(props: EmptyActivitiesProps) {
	const { title, description } = props;
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<img className={classes.imageRoot} src={emptyActivityIcon} alt="No activity" />
			<Text className={classes.title}>{title}</Text>
			<Text className={classes.description}>{description}</Text>
		</div>
	);
}

export const useStyles = makeStyles({
	imageRoot: {
		width: '128px',
		height: '128px',
		padding: '24px 0',
		paddingTop: '48px',
	},
	title: {
		fontFamily: tokens.fontFamilyBase,
		fontSize: tokens.fontSizeBase600,
		fontWeight: tokens.fontWeightSemibold,
		lineHeight: tokens.lineHeightBase300,
	},
	description: {
		fontFamily: tokens.fontFamilyBase,
		fontSize: tokens.fontSizeBase300,
		fontWeight: tokens.fontWeightRegular,
		lineHeight: tokens.lineHeightBase300,
		textAlign: 'center',
		padding: '12px 0',
	},
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		height: '100%',
	},
});